"use client"

import { useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { useAuth } from "../context/AuthContext"

const AuthRedirect = () => {
    const { isAuthenticated } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (isAuthenticated) {
            if (location.pathname === "/login") {
                navigate("/migrations", { replace: true })
            }
        }
    }, [isAuthenticated, navigate, location])

    return null
}

export default AuthRedirect

